import apiServiceCall from "../services/ApiServiceCall";

const token = "F3J92ND9J5@493SBMDJW1344JEUDJ3TES3I/3";

export const validatePaymentBySessionCode = (sessionCode: string) => {
  return apiServiceCall()
    .get(`/payment/check?session=${sessionCode}`, {
      headers: {
        "x-token": token,
      },
    })
    .then(({ data }: validatePaymentBySessionCodeResponse) => data);
};

interface validatePaymentBySessionCodeResponse {
  data: {
    ok: boolean;
  };
}
